const pageSizeMixin = {
  data() {
    return {
      pageSize: {
        viewportWidth: 0,
        viewportHeight: 0,
        documentWidth: 0,
        documentHeight: 0
      }
    }
  },
  mounted() {
    this.updateSize();
    window.addEventListener('resize', this.updateSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);
  },
  methods: {
    updateSize() {
      this.pageSize = {
        viewportWidth: document.documentElement.clientWidth || document.body.clientWidth,
        viewportHeight: document.documentElement.clientHeight || document.body.clientHeight,
        documentWidth: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth),
        documentHeight: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
      };
    }
  }
};

export default pageSizeMixin;



// WEBPACK FOOTER //
// ./src/bll/pageSize.js